<mat-form-field class="mat-select-sm" appearance="fill">
    <mat-select [(ngModel)]="year" (ngModelChange)="valueChanged()">
        <mat-option class="mat-option-sm" selected value="All">All</mat-option>
        <mat-option class="mat-option-sm" *ngFor="let option of options" [value]="option">
            {{option}}
        </mat-option>
    </mat-select>
</mat-form-field>
